import { ISSUE_TYPE } from '@qality/common-config';

export const getQAlityTypeIssues = (issues) =>
  issues.filter((i) => {
    return i.fields.issuetype?.name === ISSUE_TYPE.QALITY_TEST;
  });

export const getProjectsFromIssues = (issues) =>
  issues.reduce((accumulateProjects, issue) => {
    const { project = {} } = issue.fields;

    if (
      !accumulateProjects.find(({ id: projectId }) => projectId === project.id)
    ) {
      accumulateProjects.push(project);
    }

    return accumulateProjects;
  }, []);
